import React from 'react';

const StatsAndProcess = () => {
  // Stats Data from your image
  const stats = [
    {
      number: "2,300",
      sub: "100+",
      label: "Satisfied Customers",
      // Thumbs Up / User Tech SVG Icon
      icon: (
        <svg className="w-8 h-8 text-[#F3CA52]" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" d="M14 10h4.757a2 2 0 011.91 2.523l-1.817 6.136A2 2 0 0116.94 20H8.5c-1.105 0-2-.895-2-2V10c0-.466.16-.902.43-1.25L11.5 3l1.5 1v5h1z" />
          <path d="M6.5 10H4a2 2 0 00-2 2v6a2 2 0 002 2h2.5V10z" />
        </svg>
      )
    },
    {
      number: "2,978",
      sub: "150",
      label: "Projects Completed",
      // Folders SVG Icon
      icon: (
        <svg className="w-8 h-8 text-[#F3CA52]" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" d="M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
          <path strokeLinecap="round" strokeLinejoin="round" d="M3 7l6 4 6-4" />
        </svg>
      )
    },
    {
      number: "67",
      sub: "25+",
      label: "Launched Projects",
      // Rocket / Launch SVG Icon
      icon: (
        <svg className="w-8 h-8 text-[#F3CA52]" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
        </svg>
      )
    },
    {
      number: "+999",
      sub: "42+",
      label: "Daily Visits on our website as per GSC Report",
      // Analytics / Growth SVG Icon
      icon: (
        <svg className="w-8 h-8 text-[#F3CA52]" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
        </svg>
      )
    }
  ];

  // Process Steps Data from your image
  const steps = [
    {
      step: "01",
      title: "Onboarding",
      desc: "This is our 'nice to meet you' phase where we introduce ourselves and listen to your requirements.",
      icon: (
        <svg className="w-6 h-6 text-[#F3CA52]" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
        </svg>
      )
    },
    {
      step: "02",
      title: "REQ Gathering",
      desc: "We aim to understand your project needs, set a timeline, and share how we will achieve your goals.",
      icon: (
        <svg className="w-6 h-6 text-[#F3CA52]" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
      )
    },
    {
      step: "03",
      title: "Development",
      desc: "With your approval, we dive into content creation or development services, ensuring every detail.",
      icon: (
        <svg className="w-6 h-6 text-[#F3CA52]" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
        </svg>
      )
    },
    {
      step: "04",
      title: "Quality Assurance",
      desc: "To guarantee quality and reliability, we run the project through various testing phases and quality assurance checks.",
      icon: (
        <svg className="w-6 h-6 text-[#F3CA52]" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
        </svg>
      )
    },
    {
      step: "05",
      title: "Going Live",
      desc: "Once you are satisfied with the final product, we publish it on your desired platform.",
      icon: (
        <svg className="w-6 h-6 text-[#F3CA52]" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
        </svg>
      )
    }
  ];

  return (
    <div className="w-full bg-transparent border-none outline-none relative z-10">
      
      {/* ======================================================= */}
      {/* 📊 SUBSECTION 1: NUMBERS & STATS                         */}
      {/* ======================================================= */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-24 border-none">
        
        {/* Section Header */}
        <div className="text-center mb-8 md:mb-16">
          <h2 className="text-4xl sm:text-5xl font-black text-white tracking-tight mb-4">
            Numbers We Feel <span className="text-[#F3CA52]">Proud</span> Of!
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-transparent via-[#F3CA52] to-transparent mx-auto mt-2" />
          <p className="max-w-3xl mx-auto text-zinc-400 text-sm sm:text-base mt-4 leading-relaxed">
            Since our inception, our dedicated team has successfully completed hundreds of projects, consistently ensuring outstanding results and client satisfaction.
          </p>
        </div>

        {/* Premium Transparent Stats Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {stats.map((item, index) => (
            <div
              key={index}
              className="group relative rounded-2xl p-6 bg-zinc-950/20 backdrop-blur-md border border-zinc-900 hover:border-zinc-700/80 transition-all duration-500 transform hover:-translate-y-2 hover:scale-[1.02] flex flex-col items-center text-center shadow-lg hover:shadow-[0_0_30px_rgba(243,202,82,0.05)]"
            >
              {/* Icon Container with subtle glow */}
              <div className="p-4 rounded-xl bg-zinc-900/40 border border-zinc-800/60 mb-4 group-hover:bg-[#F3CA52]/10 group-hover:border-[#F3CA52]/30 transition-all duration-500">
                {item.icon}
              </div>

              {/* Huge Numbers */}
              <h3 className="text-4xl sm:text-5xl font-black text-white tracking-tight mb-1 group-hover:text-[#F3CA52] transition-colors duration-300">
                {item.number}
              </h3>

              {/* Sub-number indicator */}
              <span className="text-xs font-bold text-[#F3CA52] bg-[#F3CA52]/10 px-2.5 py-0.5 rounded-full border border-[#F3CA52]/20 mb-3">
                {item.sub}
              </span>

              {/* Label */}
              <p className="text-sm font-medium text-zinc-400 group-hover:text-zinc-200 transition-colors duration-300 max-w-[200px] leading-snug">
                {item.label}
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* ======================================================= */}
      {/* 🚀 SUBSECTION 2: OUR PROCESS                             */}
      {/* ======================================================= */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-24 border-none relative">
        
        {/* Section Header */}
        <div className="text-center mb-8 md:mb-20">
          <h2 className="text-4xl sm:text-5xl font-black text-white tracking-tight mb-4">
            Our <span className="text-[#F3CA52]">Process</span>
          </h2>
          <div className="w-16 h-1 bg-gradient-to-r from-transparent via-[#F3CA52] to-transparent mx-auto mt-2" />
          <p className="max-w-3xl mx-auto text-zinc-400 text-sm sm:text-base mt-4 leading-relaxed">
            At RojrzTech, we follow a streamlined and efficient process to deliver top-notch solutions. From initial discovery to final deployment, our approach ensures clarity and transparency.
          </p>
        </div>

        {/* Premium Flowing Process Pipeline Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-6 relative z-10">
          {steps.map((step, index) => (
            <div
              key={index}
              className="group relative rounded-2xl p-6 bg-zinc-950/20 backdrop-blur-md border border-zinc-900 hover:border-zinc-700/60 transition-all duration-500 transform hover:-translate-y-3 flex flex-col justify-between shadow-xl"
            >
              {/* Dynamic Number Badge Background */}
              <div className="absolute top-4 right-4 text-5xl font-black text-white/35 select-none group-hover:text-white/80 transition-colors duration-500 font-mono">
                {step.step}
              </div>

              <div>
                {/* Process Icon */}
                <div className="w-12 h-12 rounded-xl bg-zinc-900/50 border border-zinc-800 flex items-center justify-center mb-6 group-hover:border-[#F3CA52]/40 group-hover:shadow-[0_0_15px_rgba(243,202,82,0.1)] transition-all duration-500">
                  {step.icon}
                </div>

                {/* Title */}
                <h4 className="text-lg font-extrabold text-white mb-3 tracking-wide group-hover:text-[#F3CA52] transition-colors duration-300">
                  {step.title}
                </h4>

                {/* Description */}
                <p className="text-xs sm:text-sm text-zinc-400 leading-relaxed group-hover:text-zinc-300 transition-colors duration-300">
                  {step.desc}
                </p>
              </div>

              {/* Bottom Decorative Progress Bar Indicator */}
              <div className="w-full h-[2px] bg-zinc-900 mt-6 rounded-full overflow-hidden">
                <div className="w-0 h-full bg-gradient-to-r from-[#F3CA52] to-[#d4aa2e] group-hover:w-full transition-all duration-700 ease-out" />
              </div>

            </div>
          ))}
        </div>

      </div>

    </div>
  );
};

export default StatsAndProcess;